import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkIcon } from 'uitk-react-icons';
import { UitkSecondaryButton } from 'uitk-react-button';
import { UitkCheckbox } from 'uitk-react-checkbox';
import styles from './uitk-tables.css';
import { UitkTableCell } from './uitk-table-cell.esm.js';
import { UitkTableContext } from './uitk-table.esm.js';
import { UitkTableCellTag, UitkTableCellPadding } from './types.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkTableRow = function (props) {
    var _a;
    var children = props.children, checkboxA11yLabel = props.checkboxA11yLabel, isChecked = props.isChecked, className = props.className, isRowExpandable = props.isRowExpandable, onRowSelect = props.onRowSelect, rowId = props.rowId, isSelectable = props.isSelectable, expandRowA11yLabel = props.expandRowA11yLabel;
    var _b = React.useState(isChecked), checkedRow = _b[0], setCheckedRow = _b[1];
    var tableContext = React.useContext(UitkTableContext);
    var _c = React.useState(false), visible = _c[0], setVisible = _c[1];
    var rowRef = React.useRef(null);
    var isHeaderRow = children &&
        React.Children.toArray(children).some(function (child) { var _a; return ((_a = child.props) === null || _a === void 0 ? void 0 : _a.tag) === UitkTableCellTag.header; });
    React.useEffect(function () {
        setCheckedRow(isChecked);
    }, [isChecked]);
    var baseRowClass = 'uitk-table-row';
    var rowClasses = getClassNameList(baseRowClass, className, (_a = {},
        _a["".concat(baseRowClass, "-selected")] = checkedRow,
        _a["".concat(baseRowClass, "-has-expansion-trigger")] = isRowExpandable && !isHeaderRow,
        _a["".concat(baseRowClass, "-has-expansion-trigger-active")] = isRowExpandable && visible && !isHeaderRow,
        _a));
    var expansionContentClasses = getClassNameList("".concat(baseRowClass, "-expansion-content"));
    var expandoTriggerIconClasses = getClassNameList("uitk-table-expando-trigger-icon".concat(visible ? ' uitk-table-expando-trigger-icon-active' : ''));
    var onCheck = function (e) {
        typeof rowId === 'number' && (onRowSelect === null || onRowSelect === void 0 ? void 0 : onRowSelect(rowId, e.currentTarget.checked));
        setCheckedRow(e.currentTarget.checked);
    };
    var checkboxCell = (React.createElement(UitkTableCell, { className: getClassNameList('uitk-table-cell-action') },
        React.createElement(UitkCheckbox, { checked: checkedRow, labelClassName: "is-visually-hidden", onChange: onCheck, id: rowId === null || rowId === void 0 ? void 0 : rowId.toString() }, checkboxA11yLabel)));
    var expandoTriggerIcon = (React.createElement(UitkIcon, { className: expandoTriggerIconClasses, "data-testid": visible ? 'uitk-table-expando-button-icon-expanded' : undefined, name: "expand_more" }));
    var expansionClickHandler = React.useCallback(function () {
        setVisible(!visible);
    }, [visible]);
    var expansionCell = (React.createElement(UitkTableCell, { isCellExpandable: true, padding: UitkTableCellPadding.graphic },
        React.createElement(UitkSecondaryButton, { "aria-expanded": visible, "aria-controls": rowId === null || rowId === void 0 ? void 0 : rowId.toString(), "aria-label": expandRowA11yLabel, onClick: expansionClickHandler }, expandoTriggerIcon)));
    var getExpansionCellMarkup = function () {
        if (isHeaderRow) {
            return React.createElement(UitkTableCell, { isCellExpandable: true, padding: UitkTableCellPadding.graphic });
        }
        if (isRowExpandable) {
            return expansionCell;
        }
    };
    var expandableRow = (React.createElement("tr", { className: rowClasses, ref: rowRef },
        getExpansionCellMarkup(),
        isRowExpandable || isHeaderRow ? (children) : (React.createElement(UitkTableCell, { colSpan: tableContext.colSpan },
            React.createElement("div", { className: expansionContentClasses }, children)))));
    return tableContext.expandableRows || isRowExpandable ? (expandableRow) : (React.createElement("tr", { className: rowClasses },
        isSelectable && checkboxCell,
        children));
};
UitkTableRow.displayName = 'UitkTableRow';

export { UitkTableRow };
